import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Button                              from '@material-ui/core/Button/Button'
import Grid                                from '@material-ui/core/Grid'
import Typography                          from '@material-ui/core/Typography'
import { FieldArray, InjectedFormikProps } from 'formik'

import { CoachingExperience as TCoachingExperience } from '../../../api'
import withToggle, { InjectedToggleProps }           from '../../hocs/withToggle'
import CoachingExperienceCard                        from '../../molecules/CoachingExperienceCard'
import AddCoachingExperienceDialog                   from '../CoachingExperienceAddDialog'
import { i18nErrorCodes }                            from '../form-utils'

type Props =
  InjectedFormikProps<InjectedToggleProps, { coachingExperience: TCoachingExperience [] }>

const ExperiencesChunk = (props: Props) => {
  const {
    errors,
    activate,
    deactivate,
    isActive,
    values:
      {
        coachingExperience,
      },
  } = props

  const phrasing = {
    coachingCertificates: <FormattedMessage id={'project.coachingExperience'} />,
    add:                  <FormattedMessage id={'buttonActions.add'} />,
  }

  return (
    <FieldArray
      name={'coachingExperience'}
      render={({
        push,
        remove,
      }) => (
        <Grid
          container
          direction={'column'}
          spacing={16}
        >
          <Grid item>
            <Grid
              container
              justify={'space-between'}
            >
              <Grid item>
                <Typography variant={'subheading'}>
                  {phrasing.coachingCertificates}
                </Typography>
              </Grid>
              <Grid>
                <Button onClick={activate} color={'secondary'}>
                  {phrasing.add}
                </Button>
              </Grid>
            </Grid>
          </Grid>

          {coachingExperience.map((exp, i) => (
            <Grid item key={i}>
              <CoachingExperienceCard
                onRemove={() => remove(i)}
                coachingExperience={exp}
              />
            </Grid>
          ))}

          {errors.coachingExperience && (
            <Grid item>
              <Typography variant={'subheading'} color={'error'}>
                <FormattedMessage id={'validation.' + i18nErrorCodes.minOneExperienceRequired} />
              </Typography>
            </Grid>
          )}

          <AddCoachingExperienceDialog
            isOpen={isActive}
            close={deactivate}
            onClose={deactivate}
            onSubmit={values => {
              deactivate()
              push(values)
            }}
          />
        </Grid>
      )}
    />
  )
}

export default withToggle(ExperiencesChunk)



// WEBPACK FOOTER //
// ./src/components/forms/chunks/CoachingExperienceChunk.tsx